<template>
  <span
    class="trigger-booking-engine"
    :class="is_open && 'trigger-booking-engine--active'"
    @click="toggle"
  >
    {{ label }}
    <vb-icon :name="is_open ? 'cross_circle' : 'lens'" color="--info" :size="23" />
  </span>
</template>

<script>
export default {
  name: 'trigger-booking-engine',

  props: {
    is_open: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    label() {
      return this.is_open ? 'Chiudi' : 'Ricerca'
    },
  },

  methods: {
    toggle() {
      this.$emit('toggle', !this.is_open)
    },
  },
}
</script>

<style lang="scss" scoped>

  .trigger-booking-engine {
    $border: 3px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 200px;
    font-size: $font-size-lg;
    font-weight: $vb-font-weight-semibold;
    margin: ($grid-gutter-width / 2) auto 0;
    padding: ($grid-gutter-width / 3) ($grid-gutter-width / 2) ($grid-gutter-width / 3) ($grid-gutter-20);
    box-sizing: border-box;
    background-color: $extra2;
    background-clip: padding-box; /* !importanté */
    border: solid $border transparent; /* !importanté */
    border-radius: 50px;

    &--active {
      width: 135px;
    }

    &:before {
      content: '';
      position: absolute;
      top: 0; right: 0; bottom: 0; left: 0;
      z-index: -1;
      margin: -$border;
      border-radius: inherit;
      background: linear-gradient(to right, $primary, $gray-800);
    }

    @include media-breakpoint-up(lg) {
      display: none;
    }
  }

</style>